import React from 'react';
import CardsGrid from "../CardsGrid";
import Grid from "../Grid";
import Card from "../Card";
import Container from "../Container";
import IconWord from '../../public/images/word.svg';
import IconExcel from '../../public/images/excel.svg';
import IconJpg from '../../public/images/jpg.svg';
import IconHtml from '../../public/images/html.svg';
import {useTranslation} from "next-i18next";

const GridConvertToPdf = () => {
  const { t } = useTranslation(['common', 'index', 'edit-pdf']);

  return (
    <Container className="mt-xs-3 mb-xs-3 mb-md-4">
      <h3>{t('index:convert-to-pdf.title')}</h3>
      <CardsGrid>
        <Grid.Item>
          <Card
            href="/word-to-pdf"
            title={t('common:cards.word-to-pdf.title')}
            text={t('common:cards.word-to-pdf.text')}
            size='md'
            icon={IconWord}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/excel-to-pdf"
            title={t('common:cards.excel-to-pdf.title')}
            text={t('common:cards.excel-to-pdf.text')}
            size='md'
            icon={IconExcel}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/html-to-pdf"
            title={t('common:cards.html-to-pdf.title')}
            text={t('common:cards.html-to-pdf.text')}
            size='md'
            icon={IconHtml}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/jpg-to-pdf"
            title={t('common:cards.jpg-to-pdf.title')}
            text={t('common:cards.jpg-to-pdf.text')}
            size='md'
            icon={IconJpg}
          />
        </Grid.Item>
      </CardsGrid>
    </Container>
  );
};

export default GridConvertToPdf;
